<section class="the_pulse">
  <div class="container">
    <div class="row flex-lg-row-reverse">
      <div class="col-lg-6 d-flex align-items-center">
        <div class="video">
          <iframe
            src="https://www.youtube.com/embed/qnCoWkNo8Oc"
            title="Falken Tyre"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-lg-6 d-flex align-items-center">
        <div class="text white">
          <p class="sub_title">ON THE PULSE</p>
          <h2 class="title title_2 white">
            TAKING HIGH <br />
            PREMIUM PERFORMANCE <br />
            FROM RACETRACK <br />
            TO ROAD.
          </h2>
        </div>
      </div>
    </div>
  </div>
</section>
